import generateSignature from "./generate-signature";
import { getMobileNubmber } from "../utils/utils";

const FIELDS =
  "id,headline,slug,url,hero-image-s3-key,seo,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,authors,read-time,author-name,author-id,sections,story-template,cards,metadata";

const storyPageSponsoredItem = () => {
  return global
    .wretch("/api/v1/collections/sponsored-infinite-scrolls")
    .query({
      limit: 1,
    })
    .get()
    .json((response) => response.items);
};

const storyPageLoadItems = () => {
  return global
    .wretch("/api/v1/collections/top-story-home")
    .query({
      fields: FIELDS,
      limit: 4,
      offset: 0,
    })
    .get()
    .json((response) =>
      response.items.filter((i) => i.type === "story").map((story) => ({ story: story.story, otherProp: "value" }))
    );
};

export const loadStoriesForInfiniteScroll = async () => {
  const [result1, result2] = await Promise.all([storyPageSponsoredItem(), storyPageLoadItems()]);
  return [...result1, ...result2];
};

export const loadMoreCollectionItems = (slug, pageNumber) => {
  return global
    .wretch(`/api/v1/collections/${slug}`)
    .query({
      limit: 12,
      offset: pageNumber * 12,
    })
    .get()
    .json((response) => response.items.filter((i) => i.type === "story").map((story) => story.story));
};

// Get Advanced Search Stories
export function getAdvancedSearchStories(offset, itemsToLoad, queryParams) {
  const storyFields =
    "headline,subheadline,slug,url,hero-image-s3-key,hero-image-caption,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,authors,author-name,author-id,sections,story-template,metadata";

  return global
    .wretch()
    .url("/api/v1/advanced-search")
    .query({
      fields: storyFields,
      offset: offset,
      limit: itemsToLoad,
      ...queryParams,
    })
    .get()
    .json((response) => response);
}

export const getStoryPageWruData = (cid, uid, merchantId, type = "qwwidget") => {
  const WruUrl = `https://alfred.wru.ai/${merchantId}?cid=${cid}&uid=${uid}&source=true&st=${type}`;
  const [secret, date] = generateSignature(WruUrl, "keygen", "application/json");

  return global
    .wretch()
    .url(WruUrl)
    .headers({
      Authorization: `Authorization me:${secret}`,
      DateUsed: date,
      "Content-Type": "application/json",
      Accept: "application/json",
    })
    .get()
    .json((response) => response);
};

// Get Author Stories
export function getAuthorStories(authorId, offset, limit) {
  const storyFields =
    "headline,subheadline,slug,url,hero-image-s3-key,hero-image-caption,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,authors,author-name,author-id,sections,story-template,metadata";

  return global
    .wretch()
    .url(`/api/v1/authors/${authorId}/collection`)
    .query({
      "story-fields": storyFields,
      "item-type": "story",
      offset: offset,
      limit: limit,
    })
    .get()
    .json((response) => (response.items || []).map((item) => item.story));
}

export const getDmVideo = (playListId) => {
  return global.fetch(`https://api.dailymotion.com/playlist/${playListId}/videos?fields=embed_html,id,title`);
};

export const submitNewsLetter = (id, token, body) => {
  return global
    .wretch()
    .url("/subscribe")
    .query({ id, token })
    .post(body)
    .text((res) => res);
};

export const getStory = (storyId) => {
  return global
    .wretch()
    .url(`/api/v1/stories/${storyId}`)
    .get()
    .json((response) => response.story);
};

export function getWruStories(merchantId, uid, type) {
  const WruUrl = `https://alfred.wru.ai/${merchantId}?uid=${uid}&source=true&st=${type}`;
  const [secret, date] = generateSignature(WruUrl, "keygen", "application/json");

  return global
    .wretch()
    .url(WruUrl)
    .headers({
      Authorization: `Authorization me:${secret}`,
      DateUsed: date,
      "Content-Type": "application/json",
      Accept: "application/json",
    })
    .get()
    .json((response) => response);
}

export const wruUserEvent = (merchantId, body) => {
  return global
    .wretch()
    .url(`https://alfred.wru.ai/${merchantId}/user`)
    .post([body])
    .json((res) => res);
};

export function getTotalCountOfEachCollection(slug, limit = 2) {
  return global
    .wretch()
    .url(`/api/v1/collections/${slug}`)
    .query({ limit })
    .get()
    .json((response) => response);
}

// Returns the current User
export function getUser() {
  return global
    .wretch()
    .options({ credentials: "same-origin" })
    .url("/api/v1/members/me")
    .get()
    .json((res) => Promise.resolve(res))
    .catch((ex) => Promise.reject(ex));
}

export function updateUserInformation(updatedData) {
  return global
    .wretch()
    .url("/api/member/metadata")
    .post({ metadata: { userData: updatedData } })
    .res((r) => console.log("updateUserInformation response", r))
    .catch((ex) => console.log("updateUserInformation Reject", ex));
}

// Logout the User
export function logout() {
  return global
    .wretch()
    .url("/api/logout")
    .get()
    .res(() => Promise.resolve())
    .catch((ex) => Promise.reject(ex));
}

export const sendTransactionalEmail = (options) => {
  return global
    .wretch()
    .url("/frontend-api/moengage/transactional-emails")
    .headers({ "Content-Type": "application/json" })
    .post(options)
    .res((res) => res);
};

export const submitFeedbackData = (member, text) => {
  const mobileNumber = getMobileNubmber(member);
  const options = {
    formInput: `Email=${member.email}&MultiLine=${text}&PhoneNumber_countrycode=${mobileNumber}`,
  };

  return global
    .wretch()
    .url("/cancel-subscription")
    .headers({ "Content-Type": "application/json" })
    .post(options)
    .res((res) => res);
};

export const getFitStories = (collectionSlug) => {
  return global
    .wretch()
    .url(`fit-stories`)
    .query({ limit: 6, slug: collectionSlug })
    .get()
    .json((response) => response);
};

export const getMemberSubscriptionInfo = () => {
  return global
    .wretch()
    .url(`${window.location.origin}/api/access/v1/members/me/subscriptions`)
    .query({ key: "EK8k5gPbU5pG1hV5UdrPUHbT" })
    .get()
    .json((response) => response);
};

export function generateJwtToken(email, id, name) {
  return global
    .wretch()
    .url("/generate-token")
    .post({ email, id, name })
    .json((result) => result.token)
    .catch((ex) => Promise.reject(ex));
}

export function validateUser(token, redirectURL) {
  return global
    .wretch()
    .url("/api/auth/v1/login/google-one-tap")
    .post({ token, "redirect-url": redirectURL })
    .json((member) => member)
    .catch((ex) => Promise.reject(ex));
}
